"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    TOO_MANY_ATTEMPTS: {
        code: '113001',
        httpStatus: 429,
        errorLevel: 'info',
        category: 'security',
        description: 'Too many attempts to create mobile verification code',
        displayToUser: true,
        isRetryable: false,
    },
    TOO_MANY_CONSECUTIVE_ATTEMPTS: {
        code: '113002',
        httpStatus: 429,
        errorLevel: 'info',
        category: 'security',
        description: 'Too many consecutive attempts for mobile verification code. Wait a little before next attempt',
        displayToUser: true,
        isRetryable: false,
    },
    MOBILE_CODE_EXPIRED: {
        code: '113003',
        httpStatus: 403,
        description: 'Code has expired',
        displayToUser: true,
        isRetryable: false,
    },
    NO_OTP_SECRET_FOUND: {
        code: '113004',
        httpStatus: 404,
        description: 'User has no OTP Secret',
        displayToUser: false,
        isRetryable: false,
    },
    OTP_ALREADY_VERIFIED: {
        code: '113005',
        httpStatus: 403,
        description: 'User has already a verified OTP Secret',
        displayToUser: false,
        isRetryable: false,
    },
    INVALID_PHONE_NUMBER: {
        code: '113006',
        httpStatus: 400,
        errorLevel: 'info',
        category: 'tech',
        description: 'The number is not a valid phone number',
        displayToUser: true,
        isRetryable: false,
    },
    UNREACHABLE_PHONE_NUMBER: {
        code: '113007',
        httpStatus: 400,
        errorLevel: 'info',
        category: 'tech',
        description: 'The number is not currently reachable',
        displayToUser: true,
        isRetryable: true,
    },
    UNSUBSCRIBED_RECIPIENT: {
        code: '21610',
        httpStatus: 400,
        errorLevel: 'info',
        category: 'tech',
        description: 'Attempt to send to unsubscribed recipient',
        displayToUser: true,
        isRetryable: false,
    },
    FAILED_TO_VALIDATE_CODE: {
        code: '113008',
        httpStatus: 500,
        category: 'tech',
        description: 'Failed to validate mobile code',
        displayToUser: false,
        isRetryable: true,
    },
};
